import CoachProfileView from '@efdigital/ll-xceed-v2/components/coaching/coach/coach-profile.gts';
import { CoachPartnershipActions } from '@efdigital/ll-xceed-v2/components/coaching/coachee/coach-partnership-actions.gts';
import type { CoachingCoacheeCohortCoachesCoachModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/coaches/coach';
import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface CoachesCoachSignature {
  Args: {
    model: CoachingCoacheeCohortCoachesCoachModel;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Coach"}}

  <div class="container mb-3">
    <CoachProfileView
      @coach={{@model.coach}}
      @partnershipStatus={{@model.planner.getStatusForCoach @model.coach.user}}
    >
      <:actions>
        <div class="mt-4">
          <CoachPartnershipActions
            @planner={{@model.planner}}
            @coachUserId={{@model.coach.user}}
            @buttonClass="btn shadow"
          />
        </div>
      </:actions>
    </CoachProfileView>
  </div>
</template> satisfies TOC<CoachesCoachSignature>;
